import {
  useTrackComponent,
  useTrackComponentImpression,
} from '@aboutyou/tracking';
import {useSessionGender} from '../../../../shared-deprecated/sessionGender';

export const useNewsletterTracking = () => {
  const {gender} = useSessionGender();
  const trackComponent = useTrackComponent();
  const {ref} = useTrackComponentImpression({
    content_type: 'button',
    name: 'newsletter',
    context: gender ?? 'female',
  });

  const handleTrackComponent = ({
    action,
    gender,
  }: {
    action: 'impression' | 'submit';
    gender: string;
  }) => {
    trackComponent({
      action,
      content_type: 'button',
      name: 'newsletter',
      context: gender,
    });
  };

  return {ref, handleTrackComponent};
};
